import React from 'react';
import PrimaryButtonSingleVoyage
    from "@containers/singleVoyage/ui/buttonts/primaryButtonSingleVoyage/PrimaryButtonSingleVoyage";
import {useTranslation} from 'react-i18next';
import {sx} from './sx'
import Stack from '@mui/material/Stack';
import CancelIcon from '@mui/icons-material/Cancel';
import SecondaryButtonSingleVoyage
    from "@containers/singleVoyage/ui/buttonts/secondaryButtonSingleVoyage/SecondaryButtonSingleVoyage";
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import {
    useViewContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/viewContext/hooks/useViewContextMutateSingleVoyage";

interface IProps {
    onClick?: () => Promise<void>,
    disabled?: boolean
}

const OnSaveBtnCorrectionPointsModeBtnMutateSingleVoyage = ({
                                                                onClick,
                                                                disabled,
                                                            }: IProps) => {

    const {setMode} = useViewContextMutateSingleVoyage()

    const {t} = useTranslation()

    const handleClick = async () => {
        onClick && await onClick()
        setMode('points')
    }


    return (
        <Stack
            sx={sx.btn}
            direction={'row'}
            gap={1}
        >
            <PrimaryButtonSingleVoyage
                onClick={handleClick}
                startIcon={<RadioButtonCheckedIcon/>}
                disabled={disabled}
            >
                {t('singleVoyage.saveAdjustingPoints')}
            </PrimaryButtonSingleVoyage>

            <SecondaryButtonSingleVoyage
                onClick={() => setMode('points')}
                disabled={disabled}
                startIcon={<CancelIcon/>}
            >
                {t('base.cancel')}
            </SecondaryButtonSingleVoyage>

        </Stack>
    );
};

export default OnSaveBtnCorrectionPointsModeBtnMutateSingleVoyage;